import { render, staticRenderFns } from "./freeWrite.vue?vue&type=template&id=983aba4a&scoped=true"
import script from "./freeWrite.vue?vue&type=script&lang=js"
export * from "./freeWrite.vue?vue&type=script&lang=js"
import style0 from "./freeWrite.vue?vue&type=style&index=0&id=983aba4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983aba4a",
  null
  
)

export default component.exports